import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faCalendarStar,
  faDesktop,
  faMicrophone,
  faHashtag,
  faCube,
  faUnlockAlt,
  faCommentAltCheck,
  faFilter,
  faCalendarDay,
  faStream,
  faGlobe,
  faUpload,
  faBuilding,
  faUserTie,
  faMagic,
  faRandom,
  faHistory,
  faFileSpreadsheet,
  faBars,
  faFilePdf,
  faGrinAlt,
  faVideoPlus,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAppleAlt,
  faAtomAlt,
  faArrowToLeft,
  faArrowToRight,
  faArrowRight,
  faArrowSquareRight,
  faBadgeDollar,
  faBell,
  faBolt,
  faBullseyeArrow,
  faBullseyePointer,
  faCalendar,
  faCaretDown,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCog,
  faComet,
  faCopy,
  faCrown,
  faCut,
  faEdit,
  faEllipsisVAlt,
  faEllipsisHAlt,
  faEnvelope,
  faEnvelopeOpenText,
  faTruckMoving,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faFileExport,
  faFlowerDaffodil,
  faHammer,
  faHeart,
  faHome,
  faHomeHeart,
  faIceCream,
  faInfoCircle,
  faKite,
  faLink,
  faMapMarkedAlt,
  faMinusCircle,
  faMinus,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faQuestionCircle,
  faRobot,
  faSearch,
  faSmile,
  faSort,
  faSortDown,
  faSortUp,
  faUsers,
  faUserFriends,
  faGripVertical,
  faComment,
  faComments,
  faThumbtack,
  faCalendarAlt,
  faUser,
  faLightbulb,
  faSync,
  faArrowLeft,
  faDownload,
  faImage,
  faFile,
  faSun,
  faBan,
  faRecycle,
  faCalendarPlus,
  faStars,
  faTimes,
  faTimesCircle,
  faTimesSquare,
  faToggleOff,
  faToggleOn,
  faTrash,
  faTrashAlt,
  faUnlink,
  faUserLock,
  faUserPlus,
  faVideo,
  faMapMarkerSmile,
  faPlayCircle,
  faFileWord,
  faFileArchive,
  faFileExcel,
  faFilePowerpoint,
  faMusic,
  faVolumeUp,
  faPalette,
  faIcons,
  faTag,
  faWindow,
  faPennant,
  faMouse,
  faTasks,
  faCommentSmile,
  faClock,
  faPresentation,
  faMinusOctagon,
  faBriefcase,
  faGlobeAmericas,
  faExternalLink,
  faBold,
  faUnderline,
  faItalic,
  faListOl,
  faList,
  faListUl,
  faAtom,
  faHandHoldingHeart,
  faCompressAlt,
  faExpandAlt,
  faWhistle,
  faPeopleArrows,
  faSortAmountDown,
  faSortAmountUpAlt,
  faThumbsUp,
  faThumbsDown,
  faSmilePlus,
  faLongArrowRight,
  faLongArrowLeft,
  faGem,
  faFileSignature,
  faAngleUp,
  faSignOutAlt,
  faLifeRing,
  faAnalytics,
  faWrench,
  faLockAlt,
  faRedo,
  faUndo,
  faShare,
  faFileAlt,
  faHandPointRight,
  faTrafficCone,
  faFlag,
  faPrint,
  faStar,
  faDollarSign,
  faPercent,
  faTextSize,
  faHourglass,
  faLightbulbOn,
  faArrowToTop,
  faArrowToBottom,
  faMinusSquare,
  faPauseCircle,
  faSparkles,
  faExchange,
} from '@fortawesome/pro-light-svg-icons';

import {
  faThumbtack as faThumbtackSolid,
  faCircle as faCircleSolid,
  faCheckCircle as faCheckCircleSolid,
  faComment as faCommentSolid,
  faPlay as faPlaySolid,
  faStop as faStopSolid,
  faSort as faSortSolid,
  faSortUp as faSortUpSolid,
  faSortDown as faSortDownSolid,
  faList as faListSolid,
  faUser as faUserSolid,
  faStar as faStartSolid,
  faDotCircle as faDotCircleSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faExclamationCircle as faExclamationCircleSolid,
  faTimesCircle as faTimesCircleSolid,
} from '@fortawesome/free-solid-svg-icons';

import { faJira, faSlack, faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons';

// This is a set of custom created icons for use with the font awesome framework
import { faAsana, faGif, faNestedLink, faGrid, faTable, faDrag } from './custom-icons';

// arrow-up-right-and-arrow-down-left-from-center
library.add(
  faExchange,
  faTimesCircleSolid,
  faCalendarStar,
  faDesktop,
  faMicrophone,
  faArrowToTop,
  faArrowToBottom,
  faExclamationCircleSolid,
  faExclamationTriangleSolid,
  faLightbulbOn,
  faTextSize,
  faHourglass,
  faDotCircleSolid,
  faPercent,
  faDollarSign,
  faStar,
  faPrint,
  faFileAlt,
  faHandPointRight,
  faTrafficCone,
  faFlag,
  faShare,
  faRedo,
  faUndo,
  faSlack,
  faGoogle,
  faMicrosoft,
  faHashtag,
  faDrag,
  faSignOutAlt,
  faLifeRing,
  faFileSignature,
  faGem,
  faSmilePlus,
  faThumbsUp,
  faThumbsDown,
  faLongArrowRight,
  faLongArrowLeft,
  faSortAmountDown,
  faSortAmountUpAlt,
  faCube,
  faUnlockAlt,
  faLockAlt,
  faPeopleArrows,
  faStartSolid,
  faList,
  faListSolid,
  faUserSolid,
  faExpandAlt,
  faCompressAlt,
  faWhistle,
  faAtom,
  faHandHoldingHeart,
  faCommentAltCheck,
  faListOl,
  faListUl,
  faBold,
  faUnderline,
  faItalic,
  faFilter,
  faSortSolid,
  faSortUpSolid,
  faSortDownSolid,
  faGrid,
  faTable,
  faExternalLink,
  faCalendarDay,
  faStream,
  faGlobe,
  faUpload,
  faGlobeAmericas,
  faBuilding,
  faUserTie,
  faBriefcase,
  faMagic,
  faUsers,
  faMinusOctagon,
  faRandom,
  faHistory,
  faMusic,
  faBars,
  faMouse,
  faPennant,
  faTag,
  faGrinAlt,
  faPalette,
  faIcons,
  faVolumeUp,
  faFileSpreadsheet,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFilePdf,
  faFileArchive,
  faPlayCircle,
  faVideoPlus,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAppleAlt,
  faAtomAlt,
  faThumbtackSolid,
  faCircleSolid,
  faCheckCircleSolid,
  faHome,
  faPlus,
  faPlusCircle,
  faArrowToLeft,
  faArrowToRight,
  faArrowRight,
  faArrowSquareRight,
  faBadgeDollar,
  faBell,
  faBolt,
  faBullseyeArrow,
  faBullseyePointer,
  faCalendar,
  faCaretDown,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCog,
  faComet,
  faCommentSmile,
  faCopy,
  faCrown,
  faCut,
  faEdit,
  faEllipsisVAlt,
  faEllipsisHAlt,
  faEnvelope,
  faEnvelopeOpenText,
  faTruckMoving,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faFileExport,
  faFlowerDaffodil,
  faHammer,
  faHeart,
  faHome,
  faHomeHeart,
  faIceCream,
  faInfoCircle,
  faKite,
  faLink,
  faMapMarkedAlt,
  faMinusCircle,
  faMinusSquare,
  faMinus,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPlaySolid,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faQuestionCircle,
  faRobot,
  faSearch,
  faSmile,
  faSort,
  faSortDown,
  faSortUp,
  faStars,
  faStopSolid,
  faTasks,
  faTimes,
  faTimesCircle,
  faTimesSquare,
  faToggleOff,
  faToggleOn,
  faTrash,
  faTrashAlt,
  faUnlink,
  faUserFriends,
  faUserLock,
  faUserPlus,
  faVideo,
  faArrowRight,
  faArrowSquareRight,
  faCrown,
  faInfoCircle,
  faExclamationCircle,
  faCheck,
  faFileExport,
  faCircle,
  faGripVertical,
  faComment,
  faComments,
  faCommentSolid,
  faThumbtack,
  faCalendarAlt,
  faUser,
  faLightbulb,
  faSync,
  faArrowLeft,
  faDownload,
  faImage,
  faFile,
  faSun,
  faBan,
  faRecycle,
  faUnlink,
  faLink,
  faCalendar,
  faEdit,
  faCalendarPlus,
  faAsana,
  faAngleRight,
  faStars,
  faAngleLeft,
  faMapMarkerSmile,
  faGif,
  faWindow,
  faJira,
  faClock,
  faPresentation,
  faNestedLink,
  faAnalytics,
  faWrench,
  faPauseCircle,
  faSparkles
);
